// src/components/PushManager.jsx
import React, { useEffect } from "react";
import { requestPermission } from "../firebase";

/**
 * Lightweight component that requests notification permission
 * and registers the token on mount. Add <PushManager /> once
 * in your app root (e.g. App.js).
 */
const PushManager = () => {
  useEffect(() => {
    (async () => {
      await requestPermission();
    })();
  }, []);

  return null;
};

export default PushManager;
